"use client";

import clsx from "clsx";
import { FieldContainer } from "./FieldContainer";
import { fieldErrorClassname, fieldInputVariants, fieldLabelClassname } from "./field-variants";
import type { BaseFieldProps } from "./Input";
import { useFieldContext } from "../hooks/form-context";
import { useTranslations } from "next-intl";

/**
 * Textarea - Multi-line text input field
 */
export interface TextareaProps extends BaseFieldProps {
  rows?: number;
}

export const Textarea = ({ label, placeholder, required, name, rows = 4 }: TextareaProps) => {
  const field = useFieldContext();
  const t = useTranslations("ClientKeys.contact_sales_page.form");

  return (
    <FieldContainer>
      <div className='tw-flex tw-justify-between'>
        <label className={fieldLabelClassname} htmlFor={name}>
          {label}
        </label>
        {!required && <span className='tw-text-[0.75rem] tw-text-black tw-opacity-40'>{t("labels.optional")}</span>}
      </div>
      <textarea
        className={clsx(fieldInputVariants({ type: "textarea" }), "tw-resize-y")}
        id={name}
        name={name}
        placeholder={placeholder}
        required={required}
        rows={rows}
        value={field.state.value as string}
        onChange={e => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
        autoComplete='off'
      />
      {!field.state.meta.isValid && field.state.meta.isBlurred && field.state.meta.errors.length > 0 && (
        <div className={fieldErrorClassname} role='alert'>
          {field.state.meta.errors[0]}
        </div>
      )}
    </FieldContainer>
  );
};

/**
 * FieldTextarea - Alias for Textarea
 */
export const FieldTextarea = Textarea;
